import { Component } from '@angular/core';

@Component({
  selector: 'app-manifiesto',
  templateUrl: './manifiesto.component.html',
  styleUrl: './manifiesto.component.scss'
})
export class ManifiestoComponent {

}
